import { Pipe, PipeTransform } from '@angular/core';
import { FormHelper } from 'src/app/core/helpers/form.helper';
import { NullSafe } from 'src/app/core/types/null-safe.type';

/** Retorna true se o conteúdo (sem HTML) exceder o limite de caracteres — usado para exibir "ver mais". */
@Pipe({
  name: 'expandableContent',
  pure: true,
})
export class ExpandableContentPipe implements PipeTransform {
  transform(value: NullSafe<string>, limit = 300): boolean {
    return FormHelper.richTextExcedeLimite(value ?? '', limit);
  }
}
